import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from "next-i18next";
import { _postURL } from "../api";
import _ from "lodash";
import { useRouter } from "next/router";
import { AllMeta } from "../../components/seo/meta";
import { Breadcrumb } from '../../components/section/breadcrumb';
import { pagelink } from '../../config/site';
import { useEffect, useState } from 'react';
import { useScrollLock, useWindowScroll } from '@mantine/hooks';
import Link from 'next/link';
import { LoadingOverlay } from '@mantine/core';
import Subscription from "../../components/section/subscription";
import $ from 'jquery';
import Head from 'next/head';
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from "react-icons/ai";
import ArticleBonusLatest from "../../components/section/articleBonus";
import ArticleBonusMobileLatest from "../../components/section/articleBonusMobile";

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking'
    };
}

export async function getStaticProps({ locale, params: { id } }) {
    try {
        const [
            { value: { data: articleData } },
            { value: { data: latestNews } } = { data: [] },
            { value: { data: topRecommendations } = { data: [] } }
        ] = await Promise.allSettled([
            _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/article/getOneArticle`, { id: id }),
            _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/article/getRelatedArticle`, { article_id: id.split('-').at(-1) }),
            _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/article/getRecommendedCasino`),
        ]);

        if (_.isEmpty(articleData)) throw new Error();

        return {
            props: {
                articleData,
                latestNews,
                topRecommendations,
                ...(await serverSideTranslations(locale, ['common'])),
            },
            revalidate: 5
        };

    } catch (error) {
        return {
            notFound: true,
        }
    }
}

/**
 * @param {Object} props
 * @param {ArticlePageData} props.articleData
 * @param {LatestNewsData[]} props.latestNews
 * @param {TopRecommendationsData[]} props.topRecommendations
 */
export default function Index({ props, articleData, latestNews, topRecommendations }) {
    const [ voteResult, setVoteResult ] = useState(Array());
    const [ showVoteResult, setShowVoteResult ] = useState(false);
    const [ scroll, scrollTo ] = useWindowScroll();
    const [ scrollToView, setScrollToView ] = useState(false);
    const [ isProcessing, setIsProcessing ] = useState(false);
    const [ isPageLoading, setIsPageLoading ] = useState(false);
    const [ scrollLocked, setScrollLocked ] = useScrollLock(false);

    const router = useRouter();
    const { t: translate } = useTranslation();
    const { 
        article_id, cover_image, subject, description, content, publish_time, 
        meta_id, meta_title, meta_keyword, meta_description, full_name: author_name, 
        category, category_id, faq_id, faq, tag_id, tag, 
        company_id, company_logo, company_banner, company_banner_url, company_url,
        polling_id, poll_subject, poll_response, poll_responsecount, 
        general_banner, general_banner_url
    } = articleData;

    const _castVote = async (polling_id, selected) => {
        setIsProcessing(true);

        try {
            const { data: { poll_percentage, selected_text } } = await _postURL('/api/polling/submit', { polling_id, selected });

            setVoteResult(poll_percentage);
            setShowVoteResult(true);
            
        } catch (error) {
            console.log(error);

        } finally {
            setIsProcessing(false);

        }
    }

    const _hideSurvey = () => {
        if (typeof window !== 'undefined') {
            $('.survey-form-float').fadeOut(250);
            $('.survey-form-float-hide').fadeIn(250);
        }
    }

    const _showSurvey = () => {
        if (typeof window !== 'undefined') {
            setScrollToView(true);

            $('.survey-form-float-hide').fadeOut(250);
            $('.survey-form-float').fadeIn(250);
        }
    }

    useEffect(async () => {
        if (!scrollToView && scroll.y >= 750) _showSurvey();
    }, [ scroll ]);

    useEffect(() => {
        const setStatus = (stateAction) => {
            // add more action here
            setIsPageLoading(stateAction);
            setScrollLocked(stateAction);
        };

        const handleStart = url => (url !== router.asPath) && setStatus(true);
        const handleComplete = url => (url !== router.asPath) && setTimeout(() => { setStatus(false) }, 2000);

        router.events.on('routeChangeStart', handleStart);
        router.events.on('routeChangeComplete', handleComplete);
        router.events.on('routeChangeError', handleComplete);
        
        return () => {
            router.events.off('routeChangeStart', handleStart);
            router.events.off('routeChangeComplete', handleComplete);
            router.events.off('routeChangeError', handleComplete);
        }
    });

    return (
        <>
            <style dangerouslySetInnerHTML={{__html: `
                // .addthis_inline_share_toolbox {}
            `}}></style>

            <AllMeta
                title={meta_title}
                description={meta_description}
                keyword={meta_keyword}
                currentPageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${router.asPath}`}
                type="article"
                image={`${process.env.NEXT_PUBLIC_FS_URL}${cover_image}`}
            >
            </AllMeta>
            <Head><title>{meta_title}</title></Head>

            <div className="page-content">
                <LoadingOverlay visible={isPageLoading} overlayBlur={1} className='vh-100 position-absolute' style={{ top: scroll.y }}/>
                <section className="guide-sec pt-5">
                    <div className="col-11 col-lg-9 mx-auto container">
                        <div className="row">
                            <Breadcrumb
                                currentPage={{ pageName: subject, pageLink: `${process.env.NEXT_PUBLIC_FRONTEND_URL}${router.asPath}` }}
                                previousPage={[ { pageName: translate('Guide'), pageLink: pagelink.guide.homepage }, { pageName: category, pageLink: `${pagelink.guide.homepage}/${category}` } ]}
                            />
                            <div className="col-12">
                                <div className="single-article-inner">
                                    <div className="row">
                                        <div className="col-xl-8">
                                            <div className="single-article-left">
                                                <div className="single-article-box" itemScope itemType="https://schema.org/NewsArticle">
                                                    <div className="article-text">
                                                        <h1 itemProp="headline">{ subject }</h1>
                                                        <ul>
                                                            <li><span itemProp="datePublished" content={ publish_time }>{ publish_time }</span></li>
                                                            <li>{ translate('Author') }: <span itemProp="author" itemScope itemType="https://schema.org/Person"><a itemProp='url' href='/' style={{ textTransform: 'capitalize' }} ><span itemProp='name'>{ author_name }</span></a></span></li>
                                                        </ul>
                                                        <meta itemProp="image" content="https://example.com/photos/1x1/coverimage.jpg" />
                                                    </div>
                                                    <div className='article-cover-image'>
                                                        <img className='img-fluid' src={`${process.env.NEXT_PUBLIC_FS_URL}${cover_image}`} />
                                                    </div>

                                                    <ArticleBonusMobileLatest {...props} />
                                                    
                                                    <div className="article-content" style={{ overflowY: 'scroll' }} dangerouslySetInnerHTML={{ __html: content }}></div>
                                                </div>
                                                <div className="single-article-faq">
                                                    {
                                                        (!_.isEmpty(faq) && JSON.parse(faq) && JSON.parse(faq).length > 0) &&
                                                        <div itemScope itemType='https://schema.org/FAQPage' className="accordion accordion-flush " id="faqaccordion">
                                                            {
                                                                _.map(JSON.parse(faq), (faqData, index) => (
                                                                    <div itemScope itemProp='mainEntity' itemType='https://schema.org/Question' className="accordion-item custom_accordion" key={faqData.faq_id}>
                                                                        <h2 itemProp='name' className="accordion-header" id={"heading" + faqData.faq_id}>
                                                                            <button className={`accordion-button article-accordion-button ${index != 0 && 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target={"#collapse" + faqData.faq_id} aria-expanded="true" aria-controls={"collapse" + faqData.faq_id} style={{ color: '#000000', backgroundColor: 'transparent' }}>
                                                                                {faqData.subject}
                                                                                <h5>
                                                                                    <AiOutlineMinusCircle className='custon_accordion_icon_close' />
                                                                                    <AiOutlinePlusCircle className='custon_accordion_icon_open' />
                                                                                </h5>
                                                                            </button>
                                                                        </h2>
                                                                        <div itemScope itemProp='acceptedAnswer' itemType='https://schema.org/Answer' id={"collapse" + faqData.faq_id} className={`accordion-collapse collapse ${index == 0 && 'show'}`} aria-labelledby={"heading" + faqData.faq_id} data-bs-parent="#faqaccordion">
                                                                            <div itemProp='text' className="accordion-body">
                                                                                {faqData.content}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                                <div className="article-sponsord">
                                                    <ul className="sponsord-tag">
                                                        {
                                                            !_.isEmpty(tag) && _.map(JSON.parse(tag), tagData => <li key={ tagData.tag_id }><a className='disabled' style={{ cursor: 'default' }} disabled>{ tagData.display_name }</a></li>)
                                                        }
                                                    </ul>
                                                    
                                                    <div className="my-4 addthis_inline_share_toolbox"></div>

                                                    {
                                                        company_id &&
                                                        <div className="sponsord-add">
                                                            <div className="media">
                                                                <h4>{ translate('Article_sponsored_by') }</h4>
                                                                <a rel="sponsored" target='_blank' href={ company_url }>
                                                                    <span className='sponsord-add-image'>
                                                                        <img src={`${process.env.NEXT_PUBLIC_FS_URL}${company_logo}`} alt="" className="img-fluid w-100"/>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div className="image-holder">
                                                                <a rel="sponsored" target='_blank' href={ company_banner_url }>
                                                                    <img src={`${process.env.NEXT_PUBLIC_FS_URL}${company_banner}`} alt="" className="img-fluid w-100" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        (!_.isEmpty(polling_id) && !_.isEmpty(poll_subject) && !_.isEmpty(poll_response)) && 
                                                        <div className="sponsord-survey-form">
                                                            <h2>{ translate('Question_of_the_day') }</h2>
                                                            <div className="survey-form-question-btm">
                                                                { poll_subject }
                                                            </div>
                                                            <div style={{ display: showVoteResult && 'none' }}>
                                                                <LoadingOverlay visible={isProcessing} overlayBlur={1} />
                                                                {
                                                                    _.map(JSON.parse(poll_response), (pollValue, index) => (
                                                                        <div className="survey-form-options-btm" key={ index }>
                                                                            <input type="radio" id={`btm_option_${index}`} name="survey_btm" value={ pollValue } onClick={() => { _castVote(polling_id, pollValue) }} />
                                                                            <label htmlFor={`btm_option_${index}`} style={{ paddingLeft: '10px', width: '85%', cursor: 'pointer' }}>{ pollValue }</label>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                            <div style={{ display: !showVoteResult && 'none' }}>
                                                                <LoadingOverlay visible={isProcessing} overlayBlur={1} />
                                                                {
                                                                    _.map(voteResult, ({ option_text, percentage, checked }, index) => (
                                                                        /*
                                                                        <div className="progress survey-progress" key={ index }>
                                                                             <div className="progress-bar text-start survey-progress-bar" role="progressbar" style={{ width: `${percentage}%` }} aria-valuenow={ percentage } aria-valuemin="0" aria-valuemax="100">
                                                                                 <div className="survey-form-options-btm survey-progress-submitted">
                                                                                     <input type="radio" name="survey_btm" value={ option_text } checked={ checked && 'checked' } disabled="disabled" />
                                                                                     <label className="survey-option-text-submitted">{ option_text }</label>
                                                                                     <div className="survey-submitted-percentage">{ percentage }%</div>
                                                                                 </div>
                                                                             </div>
                                                                        </div>
                                                                        */
                                                                        <div key={ index } className='position-relative' style={{marginBottom: "5px"}}>
                                                                            <div className="survey-form-options-btm survey-progress-submitted">
                                                                                <input type="radio" name="survey_btm" value={ option_text } checked={ checked && 'checked' } disabled="disabled" />
                                                                                <label className="survey-option-text-submitted">{ option_text }</label>
                                                                            </div>
                                                                            <div className='survey-float-progress-outlet'>
                                                                                <div className="progress survey-progress position-relative">
                                                                                    <div className="progress-bar text-start survey-progress-bar" role="progressbar" style={{ width: `${percentage}%`, backgroundColor: checked ? '#bb9b6a' : '#d2d2d2' }} aria-valuenow={ percentage } aria-valuemin="0" aria-valuemax="100">
                                                                                        <div className="survey-submitted-percentage">{ percentage }%</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        general_banner && 
                                                        <div className="sponsord-add month-sponsord-add">
                                                            <div className="media justify-content-between">
                                                                <h4 style={{ fontSize: 12 }}>{ translate('This_month_sponsor') }</h4>
                                                                <h4 style={{ fontSize: 12 }}><a href="/monthly-sponsored"><u>{ translate('View_all_sponsor') }</u></a></h4>
                                                            </div>
                                                            <div className="image-holder">
                                                                <a rel="sponsored" target='_blank' href={ general_banner_url }>
                                                                    <img src={`${process.env.NEXT_PUBLIC_FS_URL}${general_banner}`} alt="" className="img-fluid w-100" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-4">
                                            <div className="single-article-right">
                                                <div className="latest-news">
                                                    <h4 className='custom_h4'>{ translate('Latest_news') }</h4>
                                                    <div className="col-12">
                                                        {
                                                            _.map(latestNews, ({ article_id, custom_url, cover_image, subject }, index) => (
                                                                <Link href={ `${pagelink.article.articleMidUrl}${custom_url}` } key={article_id}>
                                                                    <div className="latest-news-box" style={{ cursor: 'pointer' }}>
                                                                        <div className="image-holder">
                                                                            <img src={ cover_image ? `${process.env.NEXT_PUBLIC_FS_URL}${cover_image}` : '/assets/images/article-image-demo.png' } alt="" className="img-fluid" />
                                                                        </div>
                                                                        <div className="text-box">
                                                                            <h4>{ subject }</h4>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                
                                                <ArticleBonusLatest {...props}/>

                                                {/* {
                                                    !_.isEmpty(topRecommendations) &&
                                                    <div className="latest-news news-recommendations">
                                                        <h3>{ translate('Top_10_recommendations') }</h3>
                                                        <div className="news-recommendations-inner">
                                                            {
                                                                _.map(topRecommendations, ({ company_id, diamond_count, display_name, logo, rating }, index) => (
                                                                    <div className="news-recommendations-box">
                                                                        <div className="image-holder">
                                                                            <img src="images/recommendations-icon3.png" alt="" className="img-fluid" />
                                                                        </div>
                                                                        <div className="text-box">
                                                                            <h4>maxgoal</h4>
                                                                            <ul className="ratting">
                                                                                <li><img src="images/fill-star-icon.png" alt="" /></li>
                                                                                <li><img src="images/fill-star-icon.png" alt="" /></li>
                                                                                <li><img src="images/fill-star-icon.png" alt="" /></li>
                                                                                <li><img src="images/fill-star-icon.png" alt="" /></li>
                                                                                <li><img src="images/star-icon.png" alt="" /></li>
                                                                            </ul>
                                                                            <p><img src="images/diamond-user.png" alt="" className="img-fluid" /><span>153</span>, Rank #16</p>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                } */}
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {
                (!_.isEmpty(polling_id) && !_.isEmpty(poll_subject) && !_.isEmpty(poll_response)) && 
                <>
                    <div className="survey-form-float">
                        <div className="survey-form-float-content">
                            <div className="survey-form-float-title">{ translate('Question_of_the_day') }</div>
                            <div className="survey-form-float-question">{ poll_subject }</div>
                            <div style={{ display: showVoteResult && 'none' }}>
                                <LoadingOverlay visible={isProcessing} overlayBlur={1} />
                                <div className="survey-form-float-options-all">
                                    {
                                        _.map(JSON.parse(poll_response), (pollValue, index) => (
                                            <div className="survey-form-float-options" key={ index }>
                                                <input type="radio" id={`float_option_${index}`} name="survey_float" value={ pollValue } onClick={() => { _castVote(polling_id, pollValue) }} />
                                                <label htmlFor={`float_option_${index}`} style={{ paddingLeft: '10px', width: '85%', cursor: 'pointer' }}>{ pollValue }</label>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div style={{ display: !showVoteResult && 'none' }}>
                                <LoadingOverlay visible={isProcessing} overlayBlur={1} />
                                <div className="survey-form-float-options-all">
                                    {
                                        _.map(voteResult, ({ option_text, percentage, checked }, index) => (
                                            /*
                                            <div className="progress survey-float-progress" key={ index }>
                                                <div className="progress-bar text-start survey-float-progress-bar" role="progressbar" style={{ width: `${percentage}%` }} aria-valuenow={ percentage } aria-valuemin="0" aria-valuemax="100">
                                                    <div className="survey-form-float-options survey-float-progress-submitted">
                                                        <input type="radio" name="survey_float" value={ option_text } checked={ checked && 'checked' } disabled="disabled" />
                                                        <label className="survey-option-text-submitted">{ option_text }</label>
                                                        <div className="survey-submitted-percentage">{ percentage }%</div>
                                                    </div>
                                                </div>
                                            </div>
                                            */
                                            <div key={ index } className='position-relative' style={{ marginBottom: '5px' }}>
                                                <div className="survey-form-float-options survey-float-progress-submitted">
                                                    <input type="radio" name="survey_float" value={ option_text } checked={ checked && 'checked' } disabled="disabled" />
                                                    <label className="survey-option-text-submitted">{ option_text }</label>
                                                </div>
                                                <div className='survey-float-progress-outlet'>
                                                    <div className="progress survey-float-progress">
                                                        <div className="progress-bar text-start survey-float-progress-bar" role="progressbar" style={{ width: `${percentage}%`, backgroundColor: checked ? '#bb9b6a' : '#d2d2d2' }} aria-valuenow={ percentage } aria-valuemin="0" aria-valuemax="100">
                                                            <div className="survey-submitted-percentage">{ percentage }%</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="survey-form-float-triangle-click">
                            <a onClick={() => { _hideSurvey(); }} style={{ cursor: 'pointer' }}>
                                <img src="/assets/images/triangle-expand.png" alt="" className="img-fluid" />
                            </a>
                        </div>
                    </div>
                    <div className="survey-form-float-hide">
                        <div className="survey-form-float-content"></div>
                        <div className="survey-form-float-triangle-click-close">
                            <a onClick={() => { _showSurvey(); }} style={{ cursor: 'pointer' }}>
                                <img src="/assets/images/triangle-expand.png" alt="" className="img-fluid" />
                            </a>
                        </div>
                    </div>
                    <div className="survey-form-float-mobile-gesture d-block d-xl-none">
                        <a onClick={() => { _showSurvey() }} style={{ cursor: 'pointer' }}>
                            <img src="/assets/images/poll-hand.png" alt="" className="img-fluid" />
                        </a>
                    </div>
                </>
            }

            <Subscription />
        </>
    );
}